<template>
  <v-overlay :value="value" :absolute="absolute" :z-index="zIndex">
    <v-card color="primary" dark width="300">
      <v-card-text>
        Working...
        <v-progress-linear indeterminate color="white" class="mb-0"> </v-progress-linear>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  name: 'Busy',
  props: {
    value: {
      type: Boolean,
      description: 'Shows the busy indication'
    },
    absolute: {
      type: Boolean,
      description: 'Scopes the overlay to the parent container'
    },
    zIndex: {
      type: [Number, String],
      default: 5
    }
  }
}
</script>
